import { useSelector } from "react-redux";
import styled from "styled-components";
import { dataSelectors } from "../../../ducks/data";
import { CardTemplate } from "../../templates/CardTemplate";
import { useMaintenance } from "./hook";

export const Maintenance: React.FC = () => {
  const maintenance = useSelector(dataSelectors.maintenance);
  const {} = useMaintenance();

  return (
    <CardTemplate title={maintenance.title}>
      <Message>{maintenance.message}</Message>
      <FooterMessage>{maintenance.footer_message}</FooterMessage>
    </CardTemplate>
  );
};

const Message = styled.p`
  color: #333;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

const FooterMessage = styled.p`
  color: #333;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 21px */
`;
